import './EmiOptionBanner.css';

const EmiOptionBanner = () => (
  <div className="emi-option-banner">
    <div className="emi-option-icon" aria-hidden="true">
      <span>i</span>
    </div>
    <div className="emi-option-text">
      <p className="emi-option-title">EMI OPTIONS AVAILABLE</p>
      <p className="emi-option-subtitle">Contact us to know more - +918147454218</p>
    </div>
  </div>
);

export default EmiOptionBanner;
